export default {
  'menu.welcome': '首页',
  'menu.login': '登录',
  'menu.system': '系统管理',
  'menu.system.users': '用户管理',
  'menu.system.log': '系统日志',
  'menu.system.config': '系统配置',
  'menu.system.storage': '文件管理',
  'menu.project': '项目管理',
  'menu.project.list': '项目列表',
  'menu.projectDetail': '项目详情',
  'menu.project.dashboard': '项目仪表盘',
  'menu.alarm': '告警管理',
  'menu.task': '任务管理',
  'menu.history': '历史数据',
  'menu.group': '分组管理',
  'menu.group.group': '分组管理',
  'menu.device': '设备管理',
  'menu.device.list': '设备列表',
  'menu.device.bulkImport': '批量导入设备',
  'menu.device.detail': '设备详情',
  'menu.device.detail.info': '基本信息',
  'menu.device.detail.measurement': '测量值',
  'menu.device.detail.alarm': '告警',
  'menu.device.detail.event': '事件',
  'menu.device.detail.control': '控制',
  'menu.device.detail.child': '子设备',
  'menu.device.detail.identity': '设备外键',
  'menu.device-models': '物模型管理',
  'menu.device-model.tslType': '物模型分类',
  'menu.device-model.tsl': '物模型分类',
};
